<template lang="pug">
  dl(v-bind:class="scoreClass")
    dt.score-value
      strong {{ assessment.score }}
      sub(v-if="assessment.trendingStatus === 'DECLINING'")
        small &#9660;
      sub(v-if="assessment.trendingStatus === 'IMPROVING'")
        small &#9650;
    dd.score-type {{ label }}
</template>
<script>
export default {
  name: 'ScoreIcon',
  props: {
    assessment: {
      type: Object,
      required: true
    }
  },
  computed: {
    scoreClass() {
      let severity = this.assessment.severity;
      return {
        'score high': severity === 'SEVERE' || severity === 'EXTREMELYSEVERE',
        'score medium': severity === 'MODERATE',
        'score low': severity === 'MILD',
        'score': severity === 'NORMAL'
      };
    },
    label() {
      let name = this.assessment.assessmentName.toLowerCase();
      switch (name) {
        case 'dass21':
          if (this.assessment.categoryName === 'Anxiety') {
            return 'DASS-ANX';
          } else if (this.assessment.categoryName === 'Depression') {
            return 'DASS-DEP';
          } else {
            return 'DASS';
          }
        case 'phq9':
          return 'PHQ-9';
        case 'gad7':
          return 'GAD-7';
        case 'who-5':
          return 'WHO-5';
        default:
          return '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .score {
    @include zero;
    text-align: center;
    display: inline-block;
    padding: .15em .2em;
    background: $normal-color;
    color: #fff;
    border-radius: .15em;
    margin-right: .5em;
    margin-bottom: .5em;
    vertical-align: top;
    min-width: 3em;
    &.low {
      background: $mild-color;
    }
    &.medium {
      background: $moderate-color;
    }
    &.high {
      background: $severe-color;
    }
    dt.score-value, dd.score-type {
      @include zero;
      line-height: 1.2;
      border: none;
    }
    dt.score-value {
      font-size: $base-font-size;
    }
    dd.score-type {
      font-size: $ms-down2;
      text-transform: uppercase;
    }
  }
</style>
